<template>
    <div class="bg-white flex flex-wrap p-4">
        <Link
        v-bind="only && only.length ? { only } : {}"
        v-for="link in links" :key="link.label"
        preserve-scroll
        preserve-state
        :href="link.url ?? ''"
        v-html="link.label"
        class="flex items-center justify-center px-3 py-2 text-sm rounded-lg text-gray-600"
        :class="{ 'bg-gray-200': link.active, '!text-gray-300': !link.url }"
        />
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
export default {
    components: {
        Link
    },
    props: {
        only: Array,
        links: Array
    }
};
</script>